function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.78 130.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.77,111.55,74,122.56V90.73a5.66,5.66,0,0,1,2.9-4.94l13.34-7.44a2.34,2.34,0,0,1,3.49,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.08,73.15,19.15,57.73A2.61,2.61,0,0,0,15.24,60v44.4l34.27,19.66v-45A6.87,6.87,0,0,0,46.08,73.15Zm-3.48,41.4L22,102.48V98.16a1.16,1.16,0,0,1,1.74-1l17.35,10.17A3.11,3.11,0,0,1,42.6,110Zm0-13.86L22,88.62V84.29a1.16,1.16,0,0,1,1.74-1L41.05,93.47a3.08,3.08,0,0,1,1.55,2.68ZM42.6,86,22,74V69.64a1.16,1.16,0,0,1,1.74-1L41.05,78.82A3.08,3.08,0,0,1,42.6,81.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,49.1V89a10.45,10.45,0,0,1-5.36,9.12L63.86,120.46a10.45,10.45,0,0,1-10.17,0L13.62,98.11A10.46,10.46,0,0,1,8.27,89V35.3L53.69,10a10.4,10.4,0,0,1,10.17,0l32.2,18L104.47,23l-37.75-21a16.33,16.33,0,0,0-15.88,0L5.93,27.12A11.57,11.57,0,0,0,0,37.22v53.2a16.3,16.3,0,0,0,8.36,14.23l42.48,23.7a16.26,16.26,0,0,0,15.88,0l42.47-23.7a16.3,16.3,0,0,0,8.36-14.23V44.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,6.23a7.55,7.55,0,0,0-7.53,0L69.68,34a10,10,0,0,0-5,8.63L65,71.86a6.93,6.93,0,0,0,10.4,6l48.38-27.92a10,10,0,0,0,5-8.63V12.76A7.54,7.54,0,0,0,125,6.23Zm-4.34,33.46A5,5,0,0,1,118.19,44L77,67.75a2.66,2.66,0,0,1-4-2.28L72.72,45a6,6,0,0,1,3-5.28l41.07-23.83a2.66,2.66,0,0,1,4,2.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.79,50.67,62.28,56.53a7.11,7.11,0,0,1-7,0l-42.95-24a4.35,4.35,0,1,0-4.23,7.6L51,64.13a15.83,15.83,0,0,0,15.51,0l6.38-3.56Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxStore);
export default __webpack_public_path__ + "static/media/tx_store.a525153c8c6dc0db8fe0d67978528cd2.svg";
export { ForwardRef as ReactComponent };